<template>
  <div id="app">
    <v-app>
      <v-main>
        <main-nav id="main-nav" v-if="isLoggedIn && hasAnyCollection && currentCollection" />
        <v-container>
          <router-view />
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import MainNav from '@/components/MainNav'

export default {
  components:
  {
    MainNav
  },
  name: 'App',
  computed: {
    isLoggedIn () { return this.$store.state.authentication.status.isLoggedIn },
    hasAnyCollection () {
      return this.$store.getters['basicUserInfo/hasAnyCollection']
    },
    currentCollection () {
      return this.$store.getters['collectionContext/currentCollection']
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue